<template>
    <!--
    Timeframe component
    -->
    <div class="timeframe">
        <span v-if="label">{{ label }}</span>

        <dropdown class="dropdown-s" @changed="updatePeriod($event, 'hour', 'start')" :select="startHour" :items="hours" :default-value="defaultValue" />
        <dropdown class="dropdown-s" @changed="updatePeriod($event, 'minute', 'start')" :select="startMinute" :items="minutes" />

        <span v-if="! single">{{ $t('label.until') }}</span>

        <dropdown v-if="! single" class="dropdown-s" @changed="updatePeriod($event, 'hour', 'end')" :select="endHour" :items="hours" />
        <dropdown v-if="! single" class="dropdown-s" @changed="updatePeriod($event, 'minute', 'end')" :select="endMinute" :items="minutes" />
    </div>
</template>

<script>
import collections from '../../helpers/collections';

export default
{
    name: 'Timeframe',

    props:
    {
        selectedStart:
        {
            type: [String, Number],
        },

        selectedEnd:
        {
            type: [String, Number],
        },

        single:
        {
            type: [Boolean],
            default: false,
        },

        label:
        {
            type: [String, Boolean],
            default: false,
        },

        defaultValue:
        {
            type: String,
            default: '—'
        },
    },

    computed:
    {
        /**
         * Computed starting hour from parent scope
         */
        startHour()
        {
            return Math.floor(this.selectedStart / 60);
        },

        /**
         * Computed ending hour from parent scope
         */
        endHour()
        {
            return Math.floor(this.selectedEnd / 60);
        },

        /**
         * Computed starting minute from parent scope
         */
        startMinute()
        {
            return this.selectedStart % 60;
        },

        /**
         * Computed ending minutes from parent scope
         */
        endMinute()
        {
            return this.selectedEnd % 60;
        },

        /**
         * Available hours
         */
        hours()
        {
            return collections.hours();
        },

        /**
         * Available minutes
         */
        minutes()
        {
            return collections.minutes();
        },
    },

    methods:
    {
        /**
         * Update period
         *
         * @param value
         * @param type
         * @param position
         */
        updatePeriod(value, type, position)
        {
            let val = parseInt(value);

            if (type == 'minute')
            {
                if (position == 'start')
                {
                    this.$emit('updateStart', (this.startHour * 60) + val);
                }
                else
                {
                    this.$emit('updateEnd', (this.endHour * 60) + val);
                }
            }
            else
            {
                if (position == 'start')
                {
                    this.$emit('updateStart', (val * 60) + this.startMinute);
                }
                else
                {
                    this.$emit('updateEnd', (val * 60) + this.endMinute);
                }
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// Timeframe.vue?6adb8242